/**
* Created by kongwm.kong on 2017/7/17.
 */
 <template>
    <section class="topNav" id="topNav">
        <div class="layout_n">
            <div class="nav-ul-wrap">
                <ul class="nav-ul">
                    <li class="">
                        <div class="icon"></div>
                        <router-link to="/center">{{userName}}</router-link>
                    </li>
                    <li class="">
                        <div :class="['icon  icon1', {'active': msgNum > 0 }]"></div>
                        <router-link to="/message">消息中心</router-link>
                    </li>
                    <li class="" v-show="!isLogin">
                        <div class="icon  icon2"></div>
                        <router-link to="/login">登陆</router-link> / <router-link to="/register">注册</router-link>
                    </li>
                    <li class="logouta" v-show="isLogin" @click="logout">
                        <div class="icon  icon2"></div>
                        <a >退出登陆</a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data(){
            return {

            }
        },
        computed:{
            isLogin(){
                if(this.$store.state.isLogin){
                    this.getMsg();
                }
                return this.$store.state.isLogin;
            },
            msgNum: {
                get(){
                    return this.$store.state.msgNum;
                },
                set(v){

                }
            },
            userName(){
                let userData  = this.$store.state.userData;
                if(this.$store.state.isLogin && userData && userData!=null && userData.userName &&  userData.userName!=null){
                    return userData.userName
                } else {
                    return '个人中心'
                }
            }
        },
        mounted(){

        },
        methods: {
            getMsg(){
                this.$http.request({
                    url: `/innerMsg/newMsg`
                },(response)=>{
                    if(response.data.code ===200){
                        if(!response.data.data){
                            this.$store.commit('setMsgNum', 0);
                            this.msgNum = 0;
                        } else {
                            this.$store.commit('setMsgNum', 1);
                            this.msgNum = 1;
                        }
                    }
                },(err)=>{

                });
            },
            logout(e){
                this.$http.request({
                    url: `/account/logout`
                },(response)=>{
                    if(response.data.code ===200 && response.data.data){
                        this.$store.commit('setLogin', false);
                        this.$store.commit('setLoginData', null);
                        this.$router.push('/');
                    }
                },(err)=>{

                });
            }
        }
    }
</script>
<style lang="scss" scoped type="text/scss">
    .topNav{
        height:30px;
        background: $c_303;
        color:#fff;
        font-size: 14px;
        .nav-ul-wrap{
            float:right;
            .nav-ul{
                line-height: 30px;
                height:30px;
                li{
                    display: inline-block;
                    &+li{
                        margin-left:30px;
                    }
                    a{
                        color: #fff;
                    }
                    &.logouta{
                        cursor: pointer;
                    }
                    .icon{
                        display: inline-block;
                        position: relative;
                        width:12px;
                        height:14px;
                        vertical-align: middle;
                        margin-top: -2px ;
                        background: url(../../assets/img/common/icon1.png) left top no-repeat;
                        &.icon1{
                            background-position-y:-44px;
                        }
                        &.icon2{
                            background-position-y:bottom;
                        }
                        &.active{
                            &:after{
                                content:'';
                                width:5px;
                                height:5px;
                                background: $c_fao;
                                border-radius:50%;
                                display: block;
                                position:absolute;
                                top:0;
                                right:0;
                            }
                        }
                    }
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/common/topnav.vue